import _objectWithoutProperties from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "content", "mail", "index", "openFaq", "activeFaq", "big", "light"];
import React__default, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import Text from '../components/text/text.component.js';
import img from './faq-icon-dark.svg.js';
import img$1 from './faq-icon-light.svg.js';
var Div = styled.div.withConfig({
  displayName: "single-faqcomponent__Div",
  componentId: "sc-1uelkco-0"
})(["padding-top:34px;padding-bottom:34px;cursor:pointer;@media screen and (max-width:768px){padding-top:24px;padding-bottom:24px;}"]);
var TextTitle = styled(Text).withConfig({
  displayName: "single-faqcomponent__TextTitle",
  componentId: "sc-1uelkco-1"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:20px;line-height:28px;}"]);
var TextDescription = styled(Text).withConfig({
  displayName: "single-faqcomponent__TextDescription",
  componentId: "sc-1uelkco-2"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Regular,Arial;font-weight:400;font-size:16px;line-height:22px;}"]);
function IconArrow(props) {
  return /*#__PURE__*/React__default.createElement("img", {
    className: props.className,
    style: {
      alignSelf: "center"
    },
    src: useContext(ThemeContext) && useContext(ThemeContext).layout == "dark" ? img : img$1
  });
}
var SingleFaq = function SingleFaq(_ref) {
  var title = _ref.title,
    content = _ref.content,
    mail = _ref.mail,
    index = _ref.index,
    openFaq = _ref.openFaq,
    activeFaq = _ref.activeFaq,
    big = _ref.big,
    light = _ref.light,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Div, {
    onClick: function onClick() {
      return openFaq(index);
    },
    className: "".concat(useContext(ThemeContext) && useContext(ThemeContext).layout == "dark" ? "accordion-item-dark" : "accordion-item-light", " ").concat(activeFaq.includes(index) ? "accordion-item--opened" : "")
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "calc(100% - 20px)"
    }
  }, /*#__PURE__*/React__default.createElement(TextTitle, {
    fontFamily: "euclid",
    type: "heading",
    tag: "h4",
    fontSize: "medium",
    style: {
      marginTop: "0px"
    }
  }, title)), /*#__PURE__*/React__default.createElement(IconArrow, {
    alt: "close",
    className: "accordion-item__icon",
    width: "24",
    height: "24"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "accordion-item__inner"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "accordion-item__content",
    style: {
      paddingTop: "24px",
      paddingBottom: "0px",
      marginBottom: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(TextDescription, {
    fontFamily: "euclid",
    type: "paragraph",
    fontSize: "large",
    color: "grey-1",
    className: big ? "accordion-item__paragraph-big" : "accordion-item__paragraph"
  }, content))));
};
export { SingleFaq as default };